export const languageMapper = (language: string | undefined): string => {
  const fallbackLanguage = "en-US";
  let formattedLanguage: string = fallbackLanguage;
  language = language ?? fallbackLanguage;

  // Mapper to default languages detected with no regions
  const mapper: {
    [key: string]: string;
  } = {
    da: "da-DK",
    de: "de-DE",
    en: "en-US",
    es: "es-ES",
    fi: "fi-FI",
    fr: "fr-FR",
    it: "it-IT",
    ja: "ja-JP",
    ko: "ko-KR",
    no: "nb-NO", // Norwegian ISO 639-1 is "no" which differs from the first two characters of its country-specific codes
    nl: "nl-NL",
    pt: "pt-PT",
    ru: "ru-RU",
    sv: "sv-SE",
    tr: "tr-TR",
    zh: "zh-TW",
  };

  // List of supported languages
  const supportedLangs: string[] = [
    "da-DK",
    "de-DE",
    "en-GB",
    "en-US",
    "es-ES",
    "fi-FI",
    "fr-CA",
    "fr-FR",
    "it-IT",
    "ja-JP",
    "ko-KR",
    "nb-NO",
    "nl-NL",
    "pt-BR",
    "pt-PT",
    "ru-RU",
    "sv-SE",
    "tr-TR",
    "zh-CN",
    "zh-TW",
  ];

  if (!language.includes("-")) {
    formattedLanguage = mapper[language];
  } else {
    if (!supportedLangs.includes(language)) {
      const twoCharacterFormat = language.substring(0, 2);

      if (mapper[twoCharacterFormat]) {
        formattedLanguage = mapper[twoCharacterFormat];
      }
    } else {
      formattedLanguage = language;
    }
  }

  return formattedLanguage;
};
